var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirmTitle":'Confirmacion',"description":'Seguro que deseas cerrar este ticket'},on:{"cancel":function($event){return _vm.$emit('closeModal')},"confirm":function($event){return _vm.$emit('confirm')}}},[_c('icon-warning',{attrs:{"size":50}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }